import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

export const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'sr',
  messages: {
    en: {
      'on_off_video': 'Click on screen for videos ON/OFF',
      'other': 'Other',
      'match': 'Match',
      'round': 'Round',
      'quota': 'Quota',
      'picks': 'Tips',
      'total_odds': 'Total odds',
      'hit_total_odds': 'Hit Total odds',
      'possible_winning': 'Possible winning',
      'win': 'Win',
      'win_at': 'Win AT',
      'win_bt': 'Win BT',
      'place_bet': 'Place Bet',
      'tickets': 'Tickets',
      'champions': 'CHAMPIONS',
      'jackpot': 'JACKPOT',
      'stadium': 'STADIUM',
      'ugx': 'UGX',
      'hit': 'HIT',
      'or_more': 'OR MORE AND GET',
      'vs': 'VS',
      'results': 'RESULTS',
      'final_outcome': 'Final outcome',
      'halftime_outcome': 'Halftime outcome',
      'more_less_goals': 'More/less goals',
      'correct_result': 'Correct result',
      'goals': 'goals',
      'confirm': 'Confirm',
      'reset': 'Reset',
      'stadium_jackpot_amount': 'Stadium Jackpot Amount',
      'champion_jackpot_amount': 'Champion Jackpot Amount',
      'ticket_no': 'Ticket No.',
      'ticket_location': 'Location:',
      'close': 'Close',
      'upcoming_matches': 'UPCOMING MATCHES',
      'full_time': 'Full time',
      'half_time': 'Half time',
      'sum_of_goals': 'Sum of Goals',
      'correct_score': 'Correct Score',
      'more': 'More',
      'less': 'Less',
      'next_round_starts_in': 'Next round starts in',
      'statistics': 'Statistics',
      'total_goals': 'Total Goals',
      'last_5_matches_per_team': 'Last 5 matches per team',
      'over': 'Over',
      'under': 'Under',
      'form': 'Form',
      'form_rating': 'Form Rating',
      'l': 'L',
      'w': 'W',
      'd': 'D',
      'head_to_head': 'Head to Head',
      'last_5_matches': 'Last 5 matches',
      'draw': 'Draw',
      'change_orientation': 'Please change orientation of device',
      'cash': 'Cash',
      'fullscreen': 'Fullscreen',
      'played_ticket': 'Played ticket',
      'date': 'Date',
      'id': 'ID',
      'status': 'Status',
      'stake': 'Stake',
      'possibleWin': 'Possible Win',
      'possibleWinAT': 'Possible Win AT',
      'possibleWinBT': 'Possible Win BT',
      'tipsNumber': 'Tips',
      'betType': 'Bet Type',
      'totalOdd': 'Total Odd',
      'stakeAt': 'Stake AT',
      'stakeBt': 'Stake BT',
      'modal_connection_error': 'There is no connection with the server,<br>check internet connection or wait for<br> the application to become responsive.',
      'modal_device_rotation': 'Please rotate your phone to run<br>application in native mode. Application<br>only works in portrait mode.',
      'balance': 'BALANCE',
      'back': 'Back',
      'profile': 'Profile',
      'language': 'Language',
      'betting_history': 'Betting history',
      'enable_audio': 'Enable audio',
      'disable_audio': 'Disable audio',
      'logout': 'Logout',
      'quit_application': 'Quit application',
      'language_english': 'English UK',
      'language_serbian': 'Serbian SR',
      'language_serbian_ba': 'Serbian BA',
      'ticket': 'Ticket',
      'active_bets': 'ACTIVE BETS',
      'active_bets_small': 'Active bet',
      'last_3_champions_jackpot': 'LAST 3 CHAMPION JACKPOTS',
      'ticket_id': 'Ticket ID',
      'amount': 'Amount',
      'last_3_stadium_jackpot': 'LAST 3 STADIUM JACKPOTS',
      'hit_total_odds_slider': 'HIT TOTAL ODDS',
      'hit_total_odds_slider_2': 'OR MORE AND GET',
      'stadium_jackpot': 'STADIUM JACKPOT',
      'champions_jackpot_slide_text1': 'SAVE YOUR LOSING TICKETS, YOU WILL HAVE CHANCE TO WIN BY RANDOM DRAW',
      'champion_jackpot': 'CHAMPION JACKPOT',
      'current_round': 'Current round',
      'ends_in': 'Ends in',
      'all': 'All',
      'active': 'Active',
      'winning': 'Winning',
      'losing': 'Losing',
      'period_from': 'Period from',
      'period_to': 'Period to',
      'starts_in': 'Starts in',
      'virtual_soccer': 'Virtual Soccer',
      'grayhound_races': 'Grayhound Races',
      'my_lucky_six': 'My Lucky 6',
      'english': 'English',
      'serbian': 'Serbian',
      'activeTicket': 'Active',
      'lostTicket': 'Lost',
      'winTicket': 'Winning',
      'delete_all': 'Delete All',
      'bet_placed': 'Bet placed',
      'betting_in_progress': 'Betting in progress',
      'betting_failed': 'Betting failed',
      'no_money': 'You don\'t have enough money.',
      'kolo': 'Kolo',
      // VDOG
      'vdog_next': 'Next',
      'vdog_winner_in_first': 'WINNER / IN FIRST',
      'vdog_winner': 'Winner',
      'vdog_in_first_2': 'In First 2',
      'vdog_in_first_3': 'In First 3',
      'vdog_not_a_winner': 'Not a Winner',
      'vdog_not_in_first_2': 'Not In First 2',
      'vdog_not_in_first_3': 'Not In First 3',
      'vdog_combination_betting': 'COMBINATION BETTING',
      'vdog_double_chance': 'DOUBLE CHANCE',
      'vdog_trifecta': 'TRIFECTA',
      'vdog_first': 'First',
      'vdog_second': 'Second',
      'vdog_third': 'Third',
      'vdog_local_jackpot': 'LOCAL JACKPOT',
      'vdog_super_jackpot': 'SUPER JACKPOT',
      'vdog_hit_total_ods': 'HIT TOTAL ODDS',
      'vdog_or_more_and_get': 'OR MORE AND GET',
      'vdog_round_no': 'ROUND No.',
      'vdog_result': 'RESULT',
      'vdog_odd_even': 'ODD / EVEN',
      'vdog_low_high': 'LOW / HIGH',
      'vdog_sum_1_2_3': 'SUM 1+2+3',
      'vdog_sum_1_2': 'SUM 1+2',
      'vdog_tiket_explain': 'Ticket wins the jackpot if the random generated number is the same as the ticket number',
      'vdog_betting': 'Betting',
      'vdog_results': 'Results',
      'vdog_tickets_bets': 'Tickets / Bets',
      'vdog_possible_win': 'Possible Win',
      'vdog_total_bet': 'Total bet',
      'vdog_bet': 'BET',
      'vdog_ok': 'OK',
      'vdog_delete_all': 'Delete all',
      'vdog_place_bet': 'Place bet',
      'vdog_round': 'ROUND',
      'vdog_previous_result': 'Previous Results',
      'vdog_winner_placement_betting': 'Winner & Placement Bettings',
      'vdog_addition_betting': 'Additional Betting',
      'vdog_even': 'EVEN',
      'vdog_odd': 'ODD',
      'vdog_or': 'OR',
      'vdog_winner_starting_no': 'WINNER STARTING NO.',
      'vdog_low': 'LOW',
      'vdog_high': 'HIGH',
      'vdog_under': 'UNDER',
      'vdog_over': 'OVER',
      'vdog_first_three_dogs': 'FIRST 3 DOGS',
      'vdog_starting_no_sum': 'STARTING NO. SUM',
      'vdog_winner_runner_up': 'WINNER & RUNNER UP',
      'vdog_opposite_placement_bettinigs': 'Opposite Placement Bettings',
      'vdog_last_3_SuperJackpot': 'LAST 3 SUPER JACKPOTS',
      'vdog_last_3_LocalJackpot': 'LAST 3 LOCAL JACKPOTS',
      'vdog_date': 'Date',
      'vdog_id': 'ID',
      'vdog_status': 'Status',
      'vdog_stake': 'Stake',
      'vdog_stake_total': 'Total Stake',
      'vdog_tipsNumber': 'Tips',
      'vdog_kolo': 'Kolo',
      'vdog_betType': 'Betting type',
      'vdog_winning': 'Winning',
      'vdog_total_odds': 'Total odds',
      'vdog_total_winning': 'Total winning',
      'vdog_active_ticket': 'Active',
      'vdog_losing_ticket': 'Losing',
      'vdog': 'Dog',
      'vdog_first_trifecta': '1.',
      'vdog_second_trifecta': '2.',
      'vdog_third_trifecta': '3.',
      'vdog_ticket': 'TICKET',
      'vdog_confirm': 'Confirm',
      'vdog_1': '1',
      'vdog_2': '2',
      'vdog_3': '3',
      'vdog_4': '4',
      'vdog_5': '5',
      'vdog_6': '6',
      'vdog_sum_1_2_0': '< 7.5',
      'vdog_sum_1_2_1': '> 7.5',
      'vdog_sum_1_2_3_0': '< 10.5',
      'vdog_sum_1_2_3_1': '> 10.5',
      'vdog_log_hiw_0': '1,2,3',
      'vdog_log_hiw_1': '4,5,6',
      'vdog_odd_event_0': 'Odd',
      'vdog_odd_event_1': 'Even',
      'vdog_result_message': 'Combine Winner And Runner Up And Multiply Winnings',
      'vdog_reset': 'Reset',
      'enable_audio_modal': 'Enable audio?',
      'vdog_audio_yes': 'Yes',
      'vdog_audio_no': 'No',
      'vdog_local_jackpot_amount': 'Local Jackpot Amount',
      'vdog_super_jackpot_amount': 'Super Jackpot Amount',
      'vdog_ticket_no': 'Ticket No.',
      'vdog_ticket_location': 'Location:',
      'vdog_bet_placed': 'Bet placed',
      'vdog_betting_failed': 'Betting failed',
      'vdog_betting_in_progress': 'Betting in progress',
      'vdog_win': 'Win',
      'vdog_win_at': 'Win AT',
      'vdog_win_bt': 'Win BT',
      'vdog_no_money': 'You don\'t have enough money.',
      'vdog_possibleWin': 'Possible Win',
      'vdog_possibleWinAT': 'Possible Win AT',
      'vdog_possibleWinBT': 'Possible Win BT',
      'vdog_stakeAt': 'Stake AT',
      'vdog_stakeBt': 'Stake BT',
      'modal_betplacing_error': 'Bet placing failed<br>Message from server was<br>.',
      'api_error_3': 'You don\'t have enough money to play a ticket!',
      'api_error_5': 'An error occurred.',
      'api_error_101': 'Round is already started. No more bets.',
      'api_error_107': 'Betting on game isn\'t possible.',
      'api_error_204': 'Betting is temporary disabled. Please wait.',
      'api_error_205': 'Wrong payment! Minimim payment is {minValue}, maximum payment is {maxValue}.',
      'api_error_206': 'Wrong payment! Minimim payment is {minValue}, maximum payment is {maxValue}.',
      'api_error_207': 'Wrong payment! Minimim payment is {minValue}, maximum payment is {maxValue}.',
      'api_error_208': 'Wrong payment! Minimim payment is {minValue}, maximum payment is {maxValue}.',
      'api_error_209': 'Payout limit exceeded.  Maximum payout is {maxValue}.',
      'api_error_210': 'Cannot connect to server. ',
      'max_allowed_payment': 'Maximum allowed payment is {maxValue}',
      'min_allowed_payment': 'Minimum allowed payment is {minValue}'
    },
    ba: {
      'on_off_video': 'Kliknite na ekran da biste omogućili video',
      'other': 'Ostalo',
      'match': 'Utakmica',
      'round': 'Runda',
      'quota': 'Kvota',
      'picks': 'Broj parova',
      'total_odds': 'Ukupna kvota',
      'hit_total_odds': 'Pogodi ukupnu kvotu',
      'possible_winning': 'Mogući dobitak',
      'win': 'Dobitak',
      'win_at': 'Dobitak SP',
      'win_bt': 'Dobitak BP',
      'place_bet': 'Postavi opkladu',
      'tickets': 'Tiketi',
      'champions': 'CHAMPIONS',
      'jackpot': 'JACKPOT',
      'stadium': 'STADIUM',
      'ugx': 'UGX',
      'hit': 'POGODI',
      'or_more': 'ILI VIŠE I OSVOJI',
      'vs': 'VS',
      'results': 'REZULTATI',
      'final_outcome': 'Konačan rezultat',
      'halftime_outcome': 'Rezultat na poluvremenu',
      'more_less_goals': 'Više/manje golova',
      'correct_result': 'Tačan rezultat',
      'goals': 'golovi',
      'confirm': 'Potvrdi',
      'reset': 'Resetuj',
      'stadium_jackpot_amount': 'Stadium Jackpot Amount',
      'champion_jackpot_amount': 'Champion Jackpot Amount',
      'ticket_no': 'Tiket Br.',
      'ticket_location': 'Lokacija:',
      'close': 'Zatvori',
      'upcoming_matches': 'NAREDNI MEČEVI',
      'full_time': 'Regularno vrijeme',
      'half_time': 'Poluvrijeme',
      'sum_of_goals': 'Suma golova',
      'correct_score': 'Tačan rezultat',
      'more': 'Više',
      'less': 'Manje',
      'next_round_starts_in': 'Naredni meč počinje za',
      'statistics': 'Statistika',
      'total_goals': 'Ukupno golova',
      'last_5_matches_per_team': 'Zadnjih 5 utakmica po timu',
      'over': 'Preko',
      'under': 'Ispod',
      'form': 'Forma',
      'form_rating': 'Rejting Forme',
      'l': 'I',
      'w': 'P',
      'd': 'N',
      'head_to_head': 'Jedan protiv drugoga',
      'last_5_matches': 'Zadnjih 5 utakmica',
      'draw': 'Nerješeno',
      'change_orientation': 'Molimo Vas da rotirate uređaj',
      'cash': 'Novac',
      'fullscreen': 'Cijeli ekran',
      'played_ticket': 'Odigrani tiketi',
      'date': 'Datum',
      'id': 'ID',
      'status': 'Status',
      'stake': 'Ulog',
      'possibleWin': 'Mogući dobitak',
      'possibleWinAT': 'Mogući dobitak SP',
      'possibleWinBT': 'Mogući dobitak BP',
      'tipsNumber': 'Broj parova',
      'betType': 'Tip opklade',
      'totalOdd': 'Ukupna kvota',
      'stakeAt': 'Ulog SP',
      'stakeBt': 'Ulog BP',
      'modal_connection_error': 'Nema konekcije sa serverom,<br>provjerite internet konekciju ili sačekajte<br>da aplikacija postane responsivna.',
      'modal_device_rotation': 'Molim Vas rotirajte svoj telefon <br>kako bi aplikacija radila u nativnom modu. Aplikacija<br>radi samo u portret modu.',
      'balance': 'Saldo',
      'back': 'Nazad',
      'profile': 'Profil',
      'language': 'Jezik',
      'betting_history': 'Istorija klađenja',
      'enable_audio': 'Omogući audio',
      'disable_audio': 'Onemogući audio',
      'logout': 'Odjava',
      'quit_application': 'Izadji iz aplikacije',
      'language_english': 'Engleski UK',
      'language_serbian': 'Srpski SR',
      'language_serbian_ba': 'Srpski BA',
      'ticket': 'Tiket',
      'active_bets': 'AKTIVNE OPKLADE',
      'active_bets_small': 'Aktivne opklade',
      'last_3_champions_jackpot': 'ZADNJA 3 CHAMPIONS JACKPOTA',
      'ticket_id': 'Tiket ID',
      'amount': 'Iznos',
      'last_3_stadium_jackpot': 'ZADNJA 3 STADIUM JACKPOTA',
      'hit_total_odds_slider': 'POGODI UKUPNU KVOTU',
      'hit_total_odds_slider_2': 'ILI VIŠE I OSVOJI',
      'stadium_jackpot': 'STADIUM JACKPOT',
      'champions_jackpot_slide_text1': 'SAČUVAJ SVOJ GUBITNI TIKET, IMAŠ ŠANSU ZA DOBITKOM PUTEM SLUČAJNOG IZVLAČENJA',
      'champion_jackpot': 'CHAMPION JACKPOT',
      'current_round': 'Trenutna runda',
      'ends_in': 'Završava za',
      'all': 'Sve',
      'active': 'Aktivan',
      'winning': 'Dobitan',
      'losing': 'Gubitan',
      'period_from': 'Period od',
      'period_to': 'Period do',
      'starts_in': 'Počinje za',
      'virtual_soccer': 'Virtual Soccer',
      'grayhound_races': 'Grayhound Races',
      'my_lucky_six': 'My Lucky 6',
      'english': 'Engleski',
      'serbian': 'Srpski',
      'activeTicket': 'Aktivan',
      'lostTicket': 'Gubitan',
      'winTicket': 'Dobitan',
      'delete_all': 'Obriši sve',
      'bet_placed': 'Opklada uspješno postavljena',
      'betting_in_progress': 'Opklada se postavlja',
      'betting_failed': 'Kladjenje neuspješno',
      'no_money': 'Nema dovoljno sredstava',
      'kolo': 'Kolo',
      // VDOGS
      'vdog_next': '',
      'vdog_winner_in_first': 'POBJEDNIK / PRVI',
      'vdog_winner': 'Pobjednik',
      'vdog_in_first_2': 'U prva 2',
      'vdog_in_first_3': 'U prva 3',
      'vdog_not_a_winner': 'Nije pobjednik',
      'vdog_not_in_first_2': 'Nije u prva 2',
      'vdog_not_in_first_3': 'Nije u prva 3',
      'vdog_combination_betting': 'KOMBINOVANA KLAĐENJA',
      'vdog_double_chance': 'DUPLA ŠANSA',
      'vdog_trifecta': 'TRIFEKTA',
      'vdog_first': 'Prvi',
      'vdog_second': 'Drugi',
      'vdog_third': 'Treći',
      'vdog_odd_even': 'PAR / NEPAR',
      'vdog_low_high': 'MANJA / VEĆA',
      'vdog_sum_1_2_3': 'SUMA 1+2+3',
      'vdog_sum_1_2': 'SUMA 1+2',
      'vdog_local_jackpot': 'LOCAL JACKPOT',
      'vdog_super_jackpot': 'SUPER JACKPOT',
      'vdog_hit_total_ods': 'POGODI UKUPNU KVOTU',
      'vdog_or_more_and_get': 'ILI VIŠE I OSVOJI',
      'vdog_round_no': 'RUNDA Br.',
      'vdog_result': 'REZULTAT',
      'vdog_tiket_explain': 'Tiket osvaja jackpot ako je randomom generisani broj jednak broju tiketa',
      'vdog_betting': 'Klađenje',
      'vdog_results': 'Rezultati',
      'vdog_tickets_bets': 'Tiketi / Opklade',
      'vdog_possible_win': 'Mogući dobitak',
      'vdog_total_bet': 'Ukupni ulog',
      'vdog_bet': 'OPKLADA',
      'vdog_ok': 'OK',
      'vdog_delete_all': 'Obriši sve',
      'vdog_place_bet': 'Postavi opkladu',
      'vdog_round': 'Runda',
      'vdog_previous_result': 'Prethodni rezultati',
      'vdog_winner_placement_betting': 'Pobjednik i plasman',
      'vdog_addition_betting': 'Dodatne opklade',
      'vdog_even': 'PAR',
      'vdog_odd': 'NEPAR',
      'vdog_or': 'ILI',
      'vdog_winner_starting_no': 'BROJ POBJEDNIČKOG PSA',
      'vdog_low': 'MANJA',
      'vdog_high': 'VEĆA',
      'vdog_under': 'ISPOD',
      'vdog_over': 'PREKO',
      'vdog_first_three_dogs': 'PRVA TRI PSA',
      'vdog_starting_no_sum': 'SUMA BROJEVA',
      'vdog_winner_runner_up': 'PRVA DVA PSA',
      'vdog_opposite_placement_bettinigs': 'Klađenje na Suprotne Pozicije',
      'vdog_last_3_SuperJackpot': 'ZADNJA 3 SUPER JACKPOTA',
      'vdog_last_3_LocalJackpot': 'ZADNJA 3 LOCAL JACKPOTA',
      'vdog_date': 'Datum',
      'vdog_id': 'ID',
      'vdog_status': 'Status',
      'vdog_stake': 'Ulog',
      'vdog_stake_total': 'Ukupan ulog',
      'vdog_tipsNumber': 'Broj tipova',
      'vdog_kolo': 'Kolo',
      'vdog_betType': 'Tip opklade',
      'vdog_winning': 'Dobitan',
      'vdog_total_winning': 'Maksimalna isplata',
      'vdog_active_ticket': 'Aktivan',
      'vdog_losing_ticket': 'Gubitan',
      'vdog': 'Pas',
      'vdog_first_trifecta': '1.',
      'vdog_second_trifecta': '2.',
      'vdog_third_trifecta': '3.',
      'vdog_ticket': 'TIKET',
      'vdog_confirm': 'Potvrdi',
      'vdog_1': '1',
      'vdog_2': '2',
      'vdog_3': '3',
      'vdog_4': '4',
      'vdog_5': '5',
      'vdog_6': '6',
      'vdog_sum_1_2_0': '< 7.5',
      'vdog_sum_1_2_1': '> 7.5',
      'vdog_sum_1_2_3_0': '< 10.5',
      'vdog_sum_1_2_3_1': '> 10.5',
      'vdog_log_hiw_0': '1,2,3',
      'vdog_log_hiw_1': '4,5,6',
      'vdog_odd_event_0': 'Nepar',
      'vdog_odd_event_1': 'Par',
      'vdog_result_message': 'Kombinuj pobjednika i drugoplasiranog za množenje dobitka!',
      'vdog_reset': 'Reset',
      'enable_audio_modal': 'Omogući audio?',
      'vdog_audio_yes': 'Da',
      'vdog_audio_no': 'Ne',
      'vdog_local_jackpot_amount': 'Iznos Local Jackpota',
      'vdog_super_jackpot_amount': 'Iznos Super Jackpota',
      'vdog_ticket_no': 'Tiket Br.',
      'vdog_ticket_location': 'Lokacija:',
      'vdog_bet_placed': 'Opklada uspješno postavljena',
      'vdog_betting_failed': 'Kladjenje neuspješno',
      'vdog_betting_in_progress': 'Opklada se postavlja',
      'vdog_win': 'Dobitak',
      'vdog_win_at': 'Dobitak SP',
      'vdog_win_bt': 'Dobitak BP',
      'vdog_no_money': 'Nema dovoljno sredstava',
      'vdog_possibleWin': 'Mogući dobitak',
      'vdog_possibleWinAT': 'Mogući dobitak SP',
      'vdog_possibleWinBT': 'Mogući dobitak BP',
      'vdog_stakeAt': 'Ulog SP',
      'vdog_stakeBt': 'Ulog BP',
      'modal_betplacing_error': 'Bet placing failed<br>Message from server was<br>.',
      'api_error_3': 'Nemate dovoljno novca da biste odigrali tiket!',
      'api_error_5': 'Desila se greška.',
      'api_error_101': 'Kolo je već počelo. Klađenje nije moguće.',
      'api_error_107': 'Nije moguće klađenje na igru',
      'api_error_204': 'Klađenje je trenutno onemogućeno. Molimo Vas da sačekate.',
      'api_error_205': 'Pogrešna uplata! Minimalna uplata je {minValue} , maksimalna uplata je {maxValue}!',
      'api_error_206': 'Pogrešna uplata! Minimalna uplata je {minValue} , maksimalna uplata je {maxValue}!',
      'api_error_207': 'Pogrešna uplata! Minimalna uplata je {minValue} , maksimalna uplata je {maxValue}!',
      'api_error_208': 'Pogrešna uplata! Minimalna uplata je {minValue} , maksimalna uplata je {maxValue}!',
      'api_error_209': 'Limit isplate je premašen. Maksimalna isplata je {maxValue}.',
      'api_error_210': 'Ne može se uspostaviti veza sa serverom.',
      'max_allowed_payment': 'Maksimalna dozvoljena uplata je {maxValue}',
      'min_allowed_payment': 'Minimalna dozvoljena uplata je {minValue}'
    },
    sr: {
      'on_off_video': 'Kliknite na ekran da biste omogućili video',
      'other': 'Ostalo',
      'match': 'Utakmica',
      'round': 'Runda',
      'quota': 'Kvota',
      'picks': 'Broj parova',
      'total_odds': 'Ukupna kvota',
      'hit_total_odds': 'Pogodi ukupnu kvotu',
      'possible_winning': 'Mogući dobitak',
      'win': 'Dobitak',
      'win_at': 'Dobitak SP',
      'win_bt': 'Dobitak BP',
      'place_bet': 'Postavi opkladu',
      'tickets': 'Tiketi',
      'champions': 'CHAMPIONS',
      'jackpot': 'JACKPOT',
      'stadium': 'STADIUM',
      'ugx': 'UGX',
      'hit': 'POGODI',
      'or_more': 'ILI VIŠE I OSVOJI',
      'vs': 'VS',
      'results': 'REZULTATI',
      'final_outcome': 'Konačan rezultat',
      'halftime_outcome': 'Rezultat na poluvremenu',
      'more_less_goals': 'Više/manje golova',
      'correct_result': 'Tačan rezultat',
      'goals': 'golovi',
      'confirm': 'Potvrdi',
      'reset': 'Resetuj',
      'stadium_jackpot_amount': 'Stadium Jackpot Amount',
      'champion_jackpot_amount': 'Champion Jackpot Amount',
      'ticket_no': 'Tiket Br.',
      'ticket_location': 'Lokacija:',
      'close': 'Zatvori',
      'upcoming_matches': 'NAREDNI MEČEVI',
      'full_time': 'Regularno vreme',
      'half_time': 'Poluvreme',
      'sum_of_goals': 'Suma golova',
      'correct_score': 'Tačan rezultat',
      'more': 'Više',
      'less': 'Manje',
      'next_round_starts_in': 'Naredni meč počinje za',
      'statistics': 'Statistika',
      'total_goals': 'Ukupno golova',
      'last_5_matches_per_team': 'Zadnjih 5 utakmica po timu',
      'over': 'Preko',
      'under': 'Ispod',
      'form': 'Forma',
      'form_rating': 'Rejting Forme',
      'l': 'I',
      'w': 'P',
      'd': 'N',
      'head_to_head': 'Jedan protiv drugoga',
      'last_5_matches': 'Zadnjih 5 utakmica',
      'draw': 'Nerešeno',
      'change_orientation': 'Molimo Vas da rotirate uređaj',
      'cash': 'Novac',
      'fullscreen': 'Celi ekran',
      'played_ticket': 'Odigrani tiketi',
      'date': 'Datum',
      'status': 'Status',
      'id': 'ID',
      'stake': 'Ulog',
      'possibleWin': 'Mogući dobitak',
      'possibleWinAT': 'Mogući dobitak SP',
      'possibleWinBT': 'Mogući dobitak BP',
      'tipsNumber': 'Broj parova',
      'betType': 'Tip opklade',
      'totalOdd': 'Ukupna kvota',
      'stakeAt': 'Ulog SP',
      'stakeBt': 'Ulog BP',
      'modal_connection_error': 'Nema konekcije sa serverom,<br>proverite internet konekciju ili sačekajte<br>da aplikacija postane responsivna.',
      'modal_device_rotation': 'Molim Vas rotirajte svoj telefon <br>kako bi aplikacija radila u nativnom modu. Aplikacija<br>radi samo u portret modu.',
      'balance': 'Saldo',
      'back': 'Nazad',
      'profile': 'Profil',
      'language': 'Jezik',
      'betting_history': 'Istorija klađenja',
      'enable_audio': 'Omogući audio',
      'disable_audio': 'Onemogući audio',
      'logout': 'Odjava',
      'quit_application': 'Izadji iz aplikacije',
      'language_english': 'Engleski UK',
      'language_serbian': 'Srpski SR',
      'language_serbian_ba': 'Srpski BA',
      'ticket': 'Tiket',
      'active_bets': 'AKTIVNE OPKLADE',
      'active_bets_small': 'Aktivne opklade',
      'last_3_champions_jackpot': 'ZADNJA 3 CHAMPIONS JACKPOTA',
      'ticket_id': 'Tiket ID',
      'amount': 'Iznos',
      'last_3_stadium_jackpot': 'ZADNJA 3 STADIUM JACKPOTA',
      'hit_total_odds_slider': 'POGODI UKUPNU KVOTU',
      'hit_total_odds_slider_2': 'ILI VIŠE I OSVOJI',
      'stadium_jackpot': 'STADIUM JACKPOT',
      'champions_jackpot_slide_text1': 'SAČUVAJ SVOJ GUBITNI TIKET, IMAŠ ŠANSU ZA DOBITKOM PUTEM SLUČAJNOG IZVLAČENJA',
      'champion_jackpot': 'CHAMPION JACKPOT',
      'current_round': 'Trenutna runda',
      'ends_in': 'Završava za',
      'all': 'Sve',
      'active': 'Aktivan',
      'winning': 'Dobitan',
      'losing': 'Gubitan',
      'period_from': 'Period od',
      'period_to': 'Period do',
      'starts_in': 'Počinje za',
      'virtual_soccer': 'Virtual Soccer',
      'grayhound_races': 'Grayhound Races',
      'my_lucky_six': 'My Lucky 6',
      'english': 'Engleski',
      'serbian': 'Srpski',
      'activeTicket': 'Aktivan',
      'lostTicket': 'Gubitan',
      'winTicket': 'Dobitan',
      'delete_all': 'Obriši sve',
      'bet_placed': 'Opklada uspešno postavljena',
      'betting_in_progress': 'Opklada se postavlja',
      'betting_failed': 'Kladjenje neuspešno',
      'no_money': 'Nema dovoljno sredstava',
      'kolo': 'Kolo',
      // VDOGS
      'vdog_next': '',
      'vdog_winner_in_first': 'POBEDNIK / PRVI',
      'vdog_winner': 'Pobednik',
      'vdog_in_first_2': 'U prva 2',
      'vdog_in_first_3': 'U prva 3',
      'vdog_not_a_winner': 'Nije pobednik',
      'vdog_not_in_first_2': 'Nije u prva 2',
      'vdog_not_in_first_3': 'Nije u prva 3',
      'vdog_combination_betting': 'KOMBINOVANA KLAĐENJA',
      'vdog_double_chance': 'DUPLA ŠANSA',
      'vdog_trifecta': 'TRIFEKTA',
      'vdog_first': 'Prvi',
      'vdog_second': 'Drugi',
      'vdog_third': 'Treći',
      'vdog_odd_even': 'PAR / NEPAR',
      'vdog_low_high': 'MANJA / VEĆA',
      'vdog_sum_1_2_3': 'SUMA 1+2+3',
      'vdog_sum_1_2': 'SUMA 1+2',
      'vdog_local_jackpot': 'LOCAL JACKPOT',
      'vdog_super_jackpot': 'SUPER JACKPOT',
      'vdog_hit_total_ods': 'POGODI UKUPNU KVOTU',
      'vdog_or_more_and_get': 'ILI VIŠE I OSVOJI',
      'vdog_round_no': 'RUNDA Br.',
      'vdog_result': 'REZULTAT',
      'vdog_tiket_explain': 'Tiket osvaja jackpot ako je randomom generisani broj jednak broju tiketa',
      'vdog_betting': 'Klađenje',
      'vdog_results': 'Rezultati',
      'vdog_tickets_bets': 'Tiketi / Opklade',
      'vdog_possible_win': 'Mogući dobitak',
      'vdog_total_bet': 'Ukupni ulog',
      'vdog_bet': 'OPKLADA',
      'vdog_ok': 'OK',
      'vdog_delete_all': 'Obriši sve',
      'vdog_place_bet': 'Postavi opkladu',
      'vdog_round': 'Runda',
      'vdog_previous_result': 'Prethodni rezultati',
      'vdog_winner_placement_betting': 'Pobednik i plasman',
      'vdog_addition_betting': 'Dodatne opklade',
      'vdog_even': 'PAR',
      'vdog_odd': 'NEPAR',
      'vdog_or': 'ILI',
      'vdog_winner_starting_no': 'BROJ POBEDNIČKOG PSA',
      'vdog_low': 'MANJA',
      'vdog_high': 'VEĆA',
      'vdog_under': 'ISPOD',
      'vdog_over': 'PREKO',
      'vdog_first_three_dogs': 'PRVA TRI PSA',
      'vdog_starting_no_sum': 'SUMA BROJEVA',
      'vdog_winner_runner_up': 'PRVA DVA PSA',
      'vdog_opposite_placement_bettinigs': 'Klađenje na Suprotne Pozicije',
      'vdog_last_3_SuperJackpot': 'ZADNJA 3 SUPER JACKPOTA',
      'vdog_last_3_LocalJackpot': 'ZADNJA 3 LOCAL JACKPOTA',
      'vdog_date': 'Datum',
      'vdog_id': 'ID',
      'vdog_status': 'Status',
      'vdog_stake': 'Ulog',
      'vdog_stake_total': 'Ukupan ulog',
      'vdog_tipsNumber': 'Broj tipova',
      'vdog_kolo': 'Kolo',
      'vdog_betType': 'Tip opklade',
      'vdog_winning': 'Dobitan',
      'vdog_total_winning': 'Maksimalna isplata',
      'vdog_active_ticket': 'Aktivan',
      'vdog_losing_ticket': 'Gubitan',
      'vdog': 'Pas',
      'vdog_first_trifecta': '1.',
      'vdog_second_trifecta': '2.',
      'vdog_third_trifecta': '3.',
      'vdog_ticket': 'TIKET',
      'vdog_confirm': 'Potvrdi',
      'vdog_1': '1',
      'vdog_2': '2',
      'vdog_3': '3',
      'vdog_4': '4',
      'vdog_5': '5',
      'vdog_6': '6',
      'vdog_sum_1_2_0': '< 7.5',
      'vdog_sum_1_2_1': '> 7.5',
      'vdog_sum_1_2_3_0': '< 10.5',
      'vdog_sum_1_2_3_1': '> 10.5',
      'vdog_log_hiw_0': '1,2,3',
      'vdog_log_hiw_1': '4,5,6',
      'vdog_odd_event_0': 'Nepar',
      'vdog_odd_event_1': 'Par',
      'vdog_result_message': 'Kombinuj pobednika i drugoplasiranog za množenje dobitka!',
      'vdog_reset': 'Reset',
      'enable_audio_modal': 'Omogući audio?',
      'vdog_audio_yes': 'Da',
      'vdog_audio_no': 'Ne',
      'vdog_local_jackpot_amount': 'Iznos Local Jackpota',
      'vdog_super_jackpot_amount': 'Iznos Super Jackpota',
      'vdog_ticket_no': 'Tiket Br.',
      'vdog_ticket_location': 'Lokacija:',
      'vdog_bet_placed': 'Opklada uspešno postavljena',
      'vdog_betting_failed': 'Kladjenje neuspešno',
      'vdog_betting_in_progress': 'Opklada se postavlja',
      'vdog_win': 'Dobitak',
      'vdog_win_at': 'Dobitak SP',
      'vdog_win_bt': 'Dobitak BP',
      'vdog_no_money': 'Nema dovoljno sredstava',
      'vdog_possibleWin': 'Mogući dobitak',
      'vdog_possibleWinAT': 'Mogući dobitak SP',
      'vdog_possibleWinBT': 'Mogući dobitak BP',
      'vdog_stakeAt': 'Ulog SP',
      'vdog_stakeBt': 'Ulog BP',
      'modal_betplacing_error': 'Bet placing failed<br>Message from server was<br>.',
      'api_error_3': 'Nemate dovoljno novca da biste odigrali tiket!',
      'api_error_5': 'Desila se greška.',
      'api_error_101': 'Kolo je već počelo. Klađenje nije moguće.',
      'api_error_107': 'Nije moguće klađenje na igru',
      'api_error_204': 'Klađenje je trenutno onemogućeno. Molimo Vas da sačekate.',
      'api_error_205': 'Pogrešna uplata! Minimalna uplata je {minValue} , maksimalna uplata je {maxValue}!',
      'api_error_206': 'Pogrešna uplata! Minimalna uplata je {minValue} , maksimalna uplata je {maxValue}!',
      'api_error_207': 'Pogrešna uplata! Minimalna uplata je {minValue} , maksimalna uplata je {maxValue}!',
      'api_error_208': 'Pogrešna uplata! Minimalna uplata je {minValue} , maksimalna uplata je {maxValue}!',
      'api_error_209': 'Limit isplate je premašen. Maksimalna isplata je {maxValue}.',
      'api_error_210': 'Ne može se uspostaviti veza sa serverom.',
      'max_allowed_payment': 'Maksimalna dozvoljena uplata je {maxValue}',
      'min_allowed_payment': 'Minimalna dozvoljena uplata je {minValue}'
    }
  }
})
